import { defaultTheme } from '@yes.technology/react-toolkit'
import { TabsComponentType } from './Tabs.types'

export enum TextClassesEnum {
  extraSmall = 'content-01',
  small = 'content-02',
  semiSmall = 'content-03',
  regular = 'content-04',
  semiLarge = 'content-05',
  large = 'content-06',
  extraLarge = 'content-07',
  semiGiant = 'content-08'
}

export const textColorMap = {
  white: (defaultTheme as any).colors.whiteText as string,
  black: (defaultTheme as any).colors.blackText as string
}

export enum TextClassesEnumFocused {
  extraSmall = 'content-emphasis-01',
  small = 'content-emphasis-02',
  semiSmall = 'content-emphasis-03',
  regular = 'content-emphasis-04',
  semiLarge = 'content-emphasis-05',
  large = 'content-emphasis-06',
  extraLarge = 'content-emphasis-07',
  semiGiant = 'content-emphasis-08'
}

export const tabsComponentSizes: TabsComponentType = {
  extraSmall: {
    height: 20,
    spaceBetween: 16,
    navigationButtonSize: 20,
    separatorHeight: 12,
    separatorThickness: 0.5,
    fontSize: 8
  },
  small: {
    height: 24,
    spaceBetween: 16,
    navigationButtonSize: 24,
    separatorHeight: 14,
    separatorThickness: 1,
    fontSize: 10
  },
  semiSmall: {
    height: 32,
    spaceBetween: 24,
    navigationButtonSize: 32,
    separatorHeight: 16,
    separatorThickness: 1,
    fontSize: 12
  },
  regular: {
    height: 40,
    spaceBetween: 24,
    navigationButtonSize: 40,
    separatorHeight: 20,
    separatorThickness: 1,
    fontSize: 16
  },
  semiLarge: {
    height: 48,
    spaceBetween: 32,
    navigationButtonSize: 48,
    separatorHeight: 24,
    separatorThickness: 2,
    fontSize: 20
  },
  large: {
    height: 64,
    spaceBetween: 32,
    navigationButtonSize: 64,
    separatorHeight: 32,
    separatorThickness: 2,
    fontSize: 24
  },
  extraLarge: {
    height: 64,
    spaceBetween: 64,
    navigationButtonSize: 64,
    separatorHeight: 48,
    separatorThickness: 2,
    fontSize: 32
  },
  semiGiant: {
    height: 128,
    spaceBetween: 64,
    navigationButtonSize: 128,
    separatorHeight: 56,
    separatorThickness: 2,
    fontSize: 48
  }
}
